import React, { useEffect, useState } from 'react';
import { useWindowDimensions } from '../../styling';

export function useIsXOverflow(contentRef: React.RefObject<HTMLDivElement>, deps: React.DependencyList = []) {
  const [isXOverflow, setIsXOverflow] = useState<boolean>(false);
  useWindowDimensions();
  useEffect(() => {
    if ((contentRef?.current?.offsetWidth ?? 0) < (contentRef?.current?.scrollWidth ?? 0)) {
      setIsXOverflow(true);
    } else {
      setIsXOverflow(false);
    }
  }, [contentRef, contentRef?.current, contentRef?.current?.offsetWidth, contentRef?.current?.scrollWidth ?? 0, ...deps]);

  return isXOverflow;
}
